import { InviteUserModal } from '@linearb/linui-common';
import {
  InviteAdminEmailWrapper,
  InviteAdminEmailErrorText,
  InviteAdminSubmitWrapper,
  InviteHeader
} from './Invite.style';
import { useForm } from 'react-hook-form';
import { isPublicEmail } from 'common/utils/utils';
import { StyledInput } from 'components/base/Input';
import isEmail from 'validator/lib/isEmail';
import { accountAdminInvitation } from 'common/services/invitations.service';
import noop from 'lodash/noop';
import { ACCOUNT_TYPES_MAP } from '@linearb/linjs-common';
import { LBButton } from '@linearb/buzz';

const FORM_VALUES = {
  EMAIL: 'email'
};

const InviteAdmin = ({ open, setOpen, email = '', onInviteSuccess = noop }) => {
  const emailValue = isPublicEmail(email) ? '' : email;

  const {
    register,
    handleSubmit,
    formState: { isValid, errors },
    setError,
    reset
  } = useForm();
  const emailRegister = register(FORM_VALUES.EMAIL, {
    value: emailValue,
    required: true,
    validate: value => {
      const isValid = isEmail(value);
      setError(FORM_VALUES.EMAIL, {
        isValid
      });
      return isValid;
    }
  });

  const onSubmit = async ({ email }) => {
    try {
      const payload = {
        email,
        confirm_email: email,
        account_type_id: ACCOUNT_TYPES_MAP.Primary,
        invitee_name: email
      };
      await accountAdminInvitation(payload);
      onInviteSuccess();
    } catch (e) {
    } finally {
      reset(values => ({ ...values, [FORM_VALUES.EMAIL]: '' }));
      setOpen(false);
    }
  };

  const isEmailInvalid = errors[FORM_VALUES.EMAIL]
    ? !errors[FORM_VALUES.EMAIL].isValid
    : false;

  return (
    <InviteUserModal
      openModal={open}
      showClose
      onClose={() => {
        reset(values => ({ ...values, [FORM_VALUES.EMAIL]: '' }));
        setOpen(false);
      }}
    >
      <InviteHeader>Invite your Git organization admin</InviteHeader>
      <form onSubmit={handleSubmit(onSubmit)}>
        <InviteAdminEmailWrapper isError={isEmailInvalid}>
          <StyledInput
            isError={isEmailInvalid}
            placeholder='enter email address'
            {...emailRegister}
          />
          {isEmailInvalid && (
            <InviteAdminEmailErrorText>Invalid email</InviteAdminEmailErrorText>
          )}
        </InviteAdminEmailWrapper>
        <InviteAdminSubmitWrapper>
          <div className='absolute right-0'>
            <LBButton type='submit' size='lg' disabled={!isValid}>
              Send invite
            </LBButton>
          </div>
        </InviteAdminSubmitWrapper>
      </form>
    </InviteUserModal>
  );
};

export default InviteAdmin;
